import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Reset from '../views/Reset.vue'
import Signup from '../views/Signup.vue'

Vue.use(VueRouter)

const routes = [
    {
        path:"/",
        component:Login,
        name:"login"
    },
    {
        path: "/signup/:account",
        component:Signup,
        name:"signup"
    },
    {
        path: "/reset",
        component:Reset,
        name: "reset"
    }
]

const router = new VueRouter({
    base:'admin',
    routes
})

export default router